import { Switch } from "@mui/material";
import { styled } from "@mui/material/styles";
import React, { FC, HTMLAttributes } from "react";
import "./style.scss";

interface SwitchProps extends HTMLAttributes<HTMLDivElement> {
  inputProps?: any;
  customClass?: string;
  isDisabled?: boolean;
  onSwitchClick: any;
  isChecked: boolean;
}

const AntSwitch = styled(Switch)(({ }) => ({
  width: 28,
  height: 16,
  padding: 0,
  display: 'flex',
  '&:active': {
    '& .MuiSwitch-thumb': {
      width: 15,
    },
    '& .MuiSwitch-switchBase.Mui-checked': {
      transform: 'translateX(9px)',
    },
  },
  '& .MuiSwitch-switchBase': {
    padding: 2,
    '&.Mui-checked': {
      transform: 'translateX(12px)',
      color: '#fff',
      '& + .MuiSwitch-track': {
        opacity: 1,
        backgroundColor: '#1890ff',
      },
    },
  },
  '& .MuiSwitch-thumb': {
    boxShadow: '0 2px 4px 0 rgb(0 35 11 / 20%)',
    width: 12,
    height: 12,
    borderRadius: 6,
    transition: {
      duration: 200,
    },
  },
  '& .MuiSwitch-track': {
    borderRadius: 16 / 2,
    opacity: 1,
    backgroundColor: 'rgba(0,0,0,.25)',
    boxSizing: 'border-box',
  },
}));


const SwitchComponent: FC<SwitchProps> = (props): React.JSX.Element => {
  return (
    <AntSwitch
      checked={props.isChecked}
      inputProps={props.inputProps}
      onChange={e => {
        e.stopPropagation();
        props.onSwitchClick(e.target.checked);
      }}
      disabled={props.isDisabled}
      className={props.customClass}
    />
  );
};

export default SwitchComponent;
